var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.30069e-07 4.84623L-1.38041e-07 3.18469L1.77778 3.18469L1.77778 0.692382L3.55555 0.692382L3.55555 3.18469L5.33333 3.18469L5.33333 4.84623L-2.30069e-07 4.84623ZM1.77778 17.3078L1.77778 6.50777L3.55555 6.50777L3.55555 17.3078L1.77778 17.3078ZM5.33333 13.1539L5.33333 11.4924L7.11111 11.4924L7.11111 0.692383L8.88889 0.692383L8.88889 11.4924L10.656 11.4924L10.656 13.1539L5.33333 13.1539ZM7.11111 17.3078L7.11111 14.8155L8.88889 14.8155L8.88889 17.3078L7.11111 17.3078ZM10.6667 8.16931L10.6667 6.50777L12.4444 6.50777L12.4444 0.692383L14.2222 0.692383L14.2222 6.50777L16 6.50777L16 8.16931L10.6667 8.16931ZM12.4444 17.3078L12.4444 9.83084L14.2222 9.83084L14.2222 17.3078L12.4444 17.3078Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.0f0518198e1175a5c8e76667566e1329.svg";
export { ForwardRef as ReactComponent };